import { Component, OnInit } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { DonneeService } from './../services/donnee.service';
import { ParametreRecherche } from './../modeles/parametre-recherche.model';

@Component({
  selector: 'carte-mariale',

  template: `
    <div class="ecran">

      <cm-menu-mobile
        (afficherEcranRecherche)="afficherEcranRecherche()"
        (afficherEcranInfoLegende)="afficherEcranInfoLegende()"
        (afficherEcranFavoris)="afficherEcranFavoris()"
        (afficherEcranAPropos)="afficherEcranAPropos()"
        (afficherEcranMentionLegale)="afficherEcranMentionLegale()">
      </cm-menu-mobile>

      <div class="cadre-contenu">

        <cm-carte 
          [sites]="sitesAffiches"
          (afficheInformationSite)="afficherInformationSite($event)"
          (fermeEcranInformationSite)="fermerRecherche(); rechercher(''); fermerTousLesEcran()"
          (changeZoom)="changementZoom($event)">
        </cm-carte>

        <cm-pied-de-page
          (afficherAPropos)="fermerTousLesEcran();this.etatEcranAPropos = 'visible'"
          (afficherMentionsLegales)="fermerTousLesEcran();this.etatEcranMentionsLegales = 'visible'">
        </cm-pied-de-page>

      </div>

      <cm-menu-navigation
        *ngIf="etatEntete === 'invisible'"
        [etatEcranRecherche]="etatEcranRecherche"
        [etatEcranInfoLegende]="etatEcranInfoLegende"
        [etatEcranFiltre]="etatEcranFiltre"
        [etatEcranFavoris]="etatEcranFavoris"
        (afficherEcranRecherche)="afficherEcranRecherche()"
        (afficherEcranInfoLegende)="afficherEcranInfoLegende()"
        (afficherEcranFiltre)="afficherEcranFiltre()"
        (afficherEcranFavoris)="afficherEcranFavoris()">
      </cm-menu-navigation>

    </div>

    <div 
      *ngIf="etatEntete === 'invisible' && sites && sitesAffiches"
      class="nombre-sites-affiches"> 
      La carte affiche actuellement {{sitesAffiches.length}} des {{sites.length}} sites. 
      Agrandissez la carte pour découvrir davantage de sites.
    </div>

    <cm-entete
      [etatEntete]="etatEntete"
      (changerEtatEntete)="changerEtatEntete($event)">
    </cm-entete>

    <cm-recherche
      [etatEcran]="etatEcranRecherche"
      [sitesAffiches]="sitesAffiches"
      [parametreRecherche]="parametreRecherche"
      (fermerEcran)="fermerRecherche()"
      (rechercher)="rechercher($event)"
      (selectionner)="selectionner($event)">
    </cm-recherche>

    <cm-information
      [etatEcran]="etatEcranInformation"
      [site]="site"
      [sitesFavoris]="sitesFavoris"
      (fermerEcran)="fermerTousLesEcran()"
      (afficheInformationSite)="afficherInformationSite(site)">
    </cm-information>

    <cm-a-propos
      [etatEcran]="etatEcranAPropos"
      (fermerEcran)="fermerTousLesEcran()">
    </cm-a-propos>

    <cm-mentions-legales
      [etatEcran]="etatEcranMentionsLegales"
      (fermerEcran)="fermerTousLesEcran()">
    </cm-mentions-legales>

    <cm-info-legende
      [etatEcran]="etatEcranInfoLegende"
      (fermerEcran)="fermerTousLesEcran()">
    </cm-info-legende>

    <!--<cm-filtre
      [etatEcran]="etatEcranFiltre"
      (fermerEcran)="fermerTousLesEcran()">
    </cm-filtre>-->

    <cm-favoris
      [etatEcran]="etatEcranFavoris"
      [sitesFavoris]="sitesFavoris"
      (fermerEcran)="fermerTousLesEcran()"
      (selectionner)="selectionner($event)">
    </cm-favoris>
  `,

  styles: [`
    .ecran {
      height: 0vh;
    }
    .cadre-contenu {
      width: calc(100vw - 60px);
      background-color: white;
    }
    cm-menu-mobile {
      visibility: hidden;
    }
    .nombre-sites-affiches {
      position: absolute;
      background-color: white;
      top: calc(100vh - 65px);
      left: 0;
      padding: 2px 10px 2px 10px;
      font-size: 12px;
    }

    @media (max-width: 800px), (max-height: 700px) {
      cm-menu-navigation {
        visibility: hidden;
      }
      cm-pied-de-page {
        visibility: hidden;
      }
      cm-menu-mobile {
        visibility: visible;
      }
      .nombre-sites-affiches {
        top: calc(100vh - 20px);
        font-size: 10px;
      }
    }
  `]
})
export class CarteMarialeComponent implements OnInit {

  sites: any[];
  sitesAffiches: any[];
  sitesFavoris: any[];
  idSitesFavoris: string[];
  site: any;
  siteSelectionne: any;
  niveauZoom: number;
  parametreRecherche: ParametreRecherche;

  etatEntete: string;
  etatEcranRecherche: string;
  etatEcranInformation: string;
  etatEcranAPropos: string;
  etatEcranMentionsLegales: string;
  etatEcranInfoLegende: string;
  etatEcranFiltre: string;
  etatEcranFavoris: string;

  constructor(private http: Http, private donneeService: DonneeService) {}

  ngOnInit() {
    this.etatEntete = 'visible';
    this.niveauZoom = 4;
    this.parametreRecherche = { texteRecherche: ''};
    this.sitesFavoris = new Array();
    this.fermerTousLesEcran();
    this.obtenirDonnees();
  }

  obtenirDonnees() {
    this.sites = this.donneeService.obtenirDonnee();
    this.sitesAffiches = this.sites;
    this.filtrerSites();

    this.idSitesFavoris = this.donneeService.obtenirIdFavoris();
    this.sitesFavoris = this.sites.filter((f: any) => this.idSitesFavoris.indexOf(f.Id) > -1);
  }

  afficherEcranRecherche() {
    this.fermerTousLesEcran();
    this.etatEcranRecherche = this.etatEcranRecherche === 'invisible' ? 'visible' : 'invisible';
    this.filtrerSites();
  }

  afficherEcranInfoLegende() {
    this.fermerTousLesEcran();
    this.etatEcranInfoLegende = this.etatEcranInfoLegende === 'invisible' ? 'visible' : 'invisible';
  }

  afficherEcranFiltre() {
    this.fermerTousLesEcran();
    this.etatEcranFiltre = this.etatEcranFiltre === 'invisible' ? 'visible' : 'invisible';
  }

  afficherEcranFavoris() {
    this.fermerTousLesEcran();
    this.etatEcranFavoris = this.etatEcranFavoris === 'invisible' ? 'visible' : 'invisible';
  }

  afficherEcranAPropos() {
    this.fermerTousLesEcran();
    this.etatEcranAPropos = this.etatEcranAPropos === 'invisible' ? 'visible' : 'invisible';
  }

  afficherEcranMentionLegale() {
    this.fermerTousLesEcran();
    this.etatEcranMentionsLegales = this.etatEcranMentionsLegales === 'invisible' ? 'visible' : 'invisible';
  }

  fermerRecherche() {
    this.parametreRecherche.texteRecherche = '';
    this.fermerTousLesEcran();
  }

  afficherInformationSite(site: any) {
    this.fermerTousLesEcran();
    this.site = site;
    this.etatEcranInformation = 'visible';
  }

  fermerTousLesEcran() {
    this.etatEcranInformation = 'invisible';
    this.etatEcranRecherche = 'invisible';
    this.etatEcranAPropos = 'invisible';
    this.etatEcranRecherche = 'invisible';
    this.etatEcranMentionsLegales = 'invisible';
    this.etatEcranInfoLegende = 'invisible';
    this.etatEcranFiltre = 'invisible';
    this.etatEcranFavoris = 'invisible';
  }

  rechercher(texte: string) {
    this.parametreRecherche.texteRecherche = texte;
    this.filtrerSites();
  }

  changementZoom(zoom: number) {
    this.fermerTousLesEcran();
    this.niveauZoom = zoom;
    this.filtrerSites();
  }

  selectionner(site: any) {
    this.sitesAffiches = this.sites.filter((f: any) => f.Id === site.Id);
    this.afficherInformationSite(site);
  }

  changerEtatEntete(etatEntete: string) {
    this.etatEntete = etatEntete;
  }

  filtrerSites() {
    this.sitesAffiches = this.sites;
    if (this.parametreRecherche.texteRecherche !== '') {
      this.sitesAffiches = this.sites.filter(
        (f: any) => f.Nom.toUpperCase().indexOf(this.parametreRecherche.texteRecherche.toUpperCase()) > -1);
      const resultatPourDescription = this.sites.filter(
        (f: any) => f.Texte.toUpperCase().indexOf(this.parametreRecherche.texteRecherche.toUpperCase()) > -1
              && f.Nom.toUpperCase().indexOf(this.parametreRecherche.texteRecherche.toUpperCase()) === -1);
      this.sitesAffiches = this.sitesAffiches.concat(resultatPourDescription);
    } else {
      this.sitesAffiches = this.sitesAffiches.filter((f: any) => f.NiveauCarteMinimum <= this.niveauZoom);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/carte-mariale.component.ts